import { withProps } from "hoc-with-props";
import { FC } from "react";

import { EmptyProps } from "../../../../layout/Empty";
import { Empty } from "../../../../layout";
import { ReactComponent as Illustration } from "./assets/empty.svg";

/**
 * Empty component for game plans
 */
export default withProps({ illustration: <Illustration /> })(Empty) as FC<Omit<EmptyProps, "illustration">>;
